import { UseQueryResult, keepPreviousData } from '@tanstack/react-query'
import { sortBy } from 'lodash'
import { useMemo } from 'react'
import { z } from 'zod'

import { Asset, assetParser } from '../../models/Asset'
import * as api from '../api'
import { useApiQuery } from '../useApiQuery'
import { ReturnsAssets } from '../useInvalidate'

export default function useAssets(learningItemUuid: string) {
  const result: UseQueryResult<Asset[]> = useApiQuery({
    queryKey: ['learningItemAssets', ReturnsAssets, learningItemUuid],
    placeholderData: keepPreviousData,
    queryFn: async () =>
      z.array(assetParser).parse(await api.get(`course/${encodeURIComponent(learningItemUuid)}/asset`)),
  })

  const assets = useMemo(() => sortBy(result.data || [], 'createdAt'), [result.data])

  return {
    ...result,
    assets,
  }
}
